import { render, staticRenderFns } from "./facebookSearch.vue?vue&type=template&id=7280bfc2&"
import script from "./facebookSearch.vue?vue&type=script&lang=js&"
export * from "./facebookSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports